<template>
    <transition>
        <router-view/>
    </transition>
</template>

<script>
    export default {
        components: {
        }
    }
</script>

<style lang="scss">
    * {
        box-sizing: border-box;
    }

    body, html {
        margin: 0;
        padding: 0;
        height: 100%;
    }

    .wrapper {
        position: relative;
        max-width: 1500px;
        margin: 0 auto;
    }
</style>
